export const DISCORD_LINK = 'https://discord.gg/Xu94HFJqcw';
export const X_LINK = 'https://x.com/LeverUp_xyz';
export const GIT_BOOK_LINK = 'https://leverup.gitbook.io/docs/';
export const GIT_BOOK_TRADING_FEE =
  'https://leverup.gitbook.io/docs/trading/fee-breakdown';
export const TELEGRAM_LINK = 'https://t.me/leverup_comm';
export const TERMS_CONDITION =
  'https://leverup.gitbook.io/docs/misc/terms-of-use';
export const GIT_BOOK_AUDITS =
  'https://leverup.gitbook.io/docs/misc/audits';
export const DUNE_LINK =
  'https://dune.com/leverup_team/leverup/82be2df0-433f-4e4d-b15e-9b732bdd4285';
export const BLOG_LINK = 'https://blog.leverup.xyz/';
export const ANYCOLLATERAL_PROGRAM_LINK = 'https://ac.leverup.xyz/';
export const MONAD_BRIDGE_LINK =
  'https://monadbridge.com/?fromChain=Arbitrum&toChain=Monad&toToken=USDC&fromToken=USDC';

export const GIT_BOOK_LEVERAGE =
  'https://leverup.gitbook.io/docs/trading/opening-trades#order-type';
export const GIT_BOOK_OPEN_POSITION =
  'https://leverup.gitbook.io/docs/trading/opening-trades';

export const GIT_BOOK_TP_SL_ORDERS =
  'https://leverup.gitbook.io/docs/trading/opening-trades#order-type';
export const GIT_BOOK_RWA = 'https://leverup.gitbook.io/docs/trading/trading-rwa';
